// 区域设备开工率分布
// import uploadedDataURL from '../data-changzhou.json'
let BigDataMapChart = echarts.init(document.getElementById('YesterdayWorkTime'))
let BigDataMapChartOption = null
// BigDataMapChart.showLoading()

// BigDataMapChart.hideLoading()
axios.get('http://api.datainstance.hence.cn/api/draw/operatingRateList')
  .then((response) => {
    let DataPmJson = response.data.data
    let DataPmList = []
    let geoCoordMap = []
    DataPmJson.forEach((v, i) => {
      DataPmList.push({
        name: v.CompanyName,
        value: [v.Longitude, v.Latitude].concat(v.WorkTime)
      })
      geoCoordMap.push({
        name: v.CompanyName,
        value: v.WorkTime
      })
    })
    var convertedData = [
      DataPmList,
      DataPmList.sort(function(a, b) {
        return b.value[2] - a.value[2]
      }).slice(0, 10)
    ]
    geoCoordMap.sort(function(a, b) {
      return b.value - a.value
    })
    var categoryData = []
    var categoryBarData = []
    var barData = []
    //   var maxBar = 30;
    var sum = 0
    var count = geoCoordMap.length
    // var count = 10
    for (var i = 0; i < geoCoordMap.length; i++) {
      // categoryData.push(geoCoordMap[i].name)
      barData.push(geoCoordMap[i].value)
      sum += geoCoordMap[i].value
    }
    for (var j = 0; j < 10; j++) {
      categoryData.push(geoCoordMap[j].name)
      categoryBarData.push({
        name: geoCoordMap[j].name,
        value: geoCoordMap[j].value
      })
    }

    // console.log(categoryData)
    // console.log(sum + '   ' + count)
    BigDataMapChartOption = {
      // backgroundColor: '#021926',
      backgroundColor: 'transparent',
      animation: true,
      animationDuration: 1000,
      animationEasing: 'cubicInOut',
      animationDurationUpdate: 1000,
      animationEasingUpdate: 'cubicInOut',
      title: [{
          // text: '“区域设备开工率分布” - 常州市',
          // link: 'http://pages.anjuke.com/expert/newexpert.html',
          // subtext: 'data from Anjuke',
          // sublink: 'http://pages.anjuke.com/expert/newexpert.html',
          left: 'center',
          top: '5%',
          textStyle: {
            color: '#ccc'
          }
        }
        // ,{
        //   id: 'statistic',
        //   text: count ? '平均: ' + parseInt((sum / count).toFixed(4)) : '',
        //   right: '10%',
        //   top: '40%',
        //   width: '10%',
        //   textStyle: {
        //     color: '#fff',
        //     fontSize: 16
        //   }
        // }
      ],
      // toolbox: {
      //   iconStyle: {
      //     normal: {
      //       borderColor: '#fff'
      //     },
      //     emphasis: {
      //       borderColor: '#b1e4ff'
      //     }
      //   },
      //   feature: {
      //     dataZoom: {},
      //     brush: {
      //       type: ['rect', 'polygon', 'clear']
      //     },
      //     saveAsImage: {
      //       show: true
      //     }
      //   }
      // },
      // brush: {
      //   outOfBrush: {
      //     color: '#abc'
      //   },
      //   brushStyle: {
      //     borderWidth: 2,
      //     color: 'rgba(0,0,0,0.2)',
      //     borderColor: 'rgba(0,0,0,0.5)'
      //   },
      //   seriesIndex: [0, 1],
      //   throttleType: 'debounce',
      //   throttleDelay: 300,
      //   geoIndex: 0
      // },
      tooltip: {
        trigger: 'item',
        formatter: function(params) {
          if (typeof(params.value)[2] === 'undefined') {
            return params.name + ' : ' + params.value
          } else {
            return params.name + ' : ' + params.value[2]
          }
        }
      },
      geo: {
        map: 'changzhou',
        top: '15%',
        bottom: '7%',
        left: '5%',
        right: '25%',
        // center: [117.98561551896913, 31.205000490896193],
        // zoom: 1.5,
        label: {
          normal: {
            show: true,
            textStyle: {
              color: '#ccc'
            }
          },
          emphasis: {
            show: false
          }
        },
        roam: false, // 禁止鼠标操作地图
        // itemStyle: {
        //   normal: {
        //     areaColor: 'transparent',
        //     borderColor: '#3fdaff',
        //     borderWidth: 2,
        //     shadowColor: 'rgba(63, 218, 255, 0.5)',
        //     shadowBlur: 30
        //   },
        //   emphasis: {
        //     areaColor: '#2B91B7'
        //   }
        // }
        itemStyle: {
          normal: {
            areaColor: '#323c48',
            borderColor: '#111'
          },
          emphasis: {
            areaColor: '#2a333d'
          }
        }
      },
      grid: {
        right: '10%',
        top: '20%',
        bottom: '20%',
        width: '10%'
      },
      xAxis: {
        type: 'value',
        scale: true,
        // position: 'top',
        boundaryGap: false,
        splitLine: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: false,
          margin: 2,
          textStyle: {
            color: '#aaa'
          }
        }
      },
      yAxis: {
        type: 'category',
        //  name: 'TOP 20',
        nameGap: 16,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ddd'
          }
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: '#ddd'
          }
        },
        axisLabel: {
          show: false,
          interval: 0,
          textStyle: {
            color: '#ddd'
          }
        },
        data: categoryData.reverse()
      },
      series: [{
        // name: '',
        type: 'scatter',
        coordinateSystem: 'geo',
        data: convertedData[0],
        symbolSize: function(val) {
          return Math.max(val[2] / 5, 8)
        },
        label: {
          normal: {
            formatter: '{b}',
            position: 'right',
            show: false
          },
          emphasis: {
            show: true
          }
        },
        itemStyle: {
          normal: {
            color: '#FF8C00',
            position: 'right',
            show: true
          }
        }
      }, {
        //  name: 'Top 5',
        type: 'effectScatter',
        coordinateSystem: 'geo',
        data: convertedData[0],
        symbolSize: function(val) {
          return Math.max(val[2] / 10, 8)
        },
        showEffectOn: 'render',
        rippleEffect: {
          brushType: 'stroke'
        },
        hoverAnimation: true,
        label: {
          normal: {
            formatter: '{b}',
            position: 'right',
            show: false
          }
        },
        itemStyle: {
          normal: {
            color: '#f4e925',
            shadowBlur: 50,
            shadowColor: '#EE0000'
          }
        },
        zlevel: 1
      }, {
        id: 'bar',
        zlevel: 2,
        type: 'bar',
        symbol: 'none',
        itemStyle: {
          normal: {
            color: '#ddb926'
          }
        },

        data: categoryBarData.reverse()
      }]

    }
    if (BigDataMapChartOption && typeof BigDataMapChartOption === 'object') {
      BigDataMapChart.setOption(BigDataMapChartOption, true)
    }
  })
  .catch((error) => {
    console.log(error)
  })

// PM2.5
let BigDataMapChart1 = echarts.init(document.getElementById('YesterdayDeviceStatus'))
let BigDataMapChart1Option = null
axios.get('http://api.datainstance.hence.cn/api/draw/airQualityIndexList')
  .then((response) => {
    let DataPmJson = response.data.data
    let DataPmList = []
    let DataPmData = []
    DataPmJson.forEach((v, i) => {
      DataPmList.push({
        id: v.Id,
        name: `监测点${i + 1}`,
        value: [v.Longitude, v.Latitude].concat(v.AQI)
      })
      DataPmData.push({
        name: `监测点${i + 1}`,
        value: v.AQI
      })
    })
    let max = 480
    let min = 9 // todo
    let maxSize4Pin = 100
    let minSize4Pin = 20

    BigDataMapChart1Option = {
      backgroundColor: 'transparent',
      title: {
        // text: '“PM2.5” - 常州市',
        // subtext: '',
        left: 'center',
        top: '5%',
        textStyle: {
          color: '#ccc'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: function(params) {
          if (typeof(params.value)[2] === 'undefined') {
            return params.name + ' : ' + params.value
          } else {
            return params.name + ' : ' + params.value[2]
          }
        }
      },
      // legend: {
      //   orient: 'vertical',
      //   y: 'bottom',
      //   x: 'right',
      //   data: ['credit_pm2.5'],
      //   textStyle: {
      //     color: '#fff'
      //   }
      // },
      visualMap: {
        show: false,
        left: 'left',
        min: 0,
        max: 90,
        top: 'bottom',
        text: ['高', '低'], // 文本，默认为数值文本
        calculable: true,
        seriesIndex: [1],
        inRange: {
          // color: ['#3B5077', '#031525'], // 蓝黑
          // color: ['#ffc0cb', '#800080'], // 红紫
          // color: ['#3C3B3F', '#605C3C'], // 黑绿
          // color: ['#0f0c29', '#302b63', '#24243e'] // 黑紫黑
          // color: ['#23074d', '#cc5333'], // 紫红
          // color: ['#00467F', '#A5CC82'], // 蓝绿
          // color: ['#1488CC', '#2B32B2'], // 浅蓝
          // color: ['#00467F', '#A5CC82'], // 蓝绿
          // color: ['#00467F', '#A5CC82'], // 蓝绿
          // color: ['#00467F', '#A5CC82'], // 蓝绿
          // color: ['#00467F', '#A5CC82'] // 蓝绿
          color: ['#A5CC82', '#fffa00', '#ff5041']
        }
      },
      // toolbox: {
      //     show: true,
      //     orient: 'vertical',
      //     left: 'right',
      //     top: 'center',
      //     feature: {
      //             dataView: {readOnly: false},
      //             restore: {},
      //             saveAsImage: {}
      //             }
      // },
      geo: {
        map: 'changzhou',
        top: '20%',
        bottom: '7%',
        left: '5%',
        right: '20%',
        // center: [117.98561551896913, 31.205000490896193],
        // zoom: 1.5,
        label: {
          normal: {
            show: true,
            textStyle: {
              color: '#ccc'
            }
          },
          emphasis: {
            show: false
          }
        },
        roam: false, // 禁止鼠标操作地图
        itemStyle: {
          normal: {
            areaColor: '#323c48',
            borderColor: '#111'
          },
          emphasis: {
            areaColor: '#2a333d'
          }
        }
      },
      series: [{
          type: 'map',
          tooltip: {
            show: false
          },
          map: 'changzhou',
          geoIndex: 0,
          aspectScale: 0.75, // 长宽比
          showLegendSymbol: false, // 存在legend时显示
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false,
              textStyle: {
                color: '#fff'
              }
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: '#031525',
              borderColor: '#3B5077'
            },
            emphasis: {
              areaColor: '#2B91B7'
            }
          },
          animation: false
        },
        {
          name: '点',
          type: 'scatter',
          coordinateSystem: 'geo',
          symbol: 'pin',
          symbolSize: function(val) {
            var a = (maxSize4Pin - minSize4Pin) / (max - min)
            var b = minSize4Pin - a * min
            b = maxSize4Pin - a * max
            return a * val[2] * 2 + b
          },
          label: {
            normal: {
              formatter: function(params) {
                return params.value[2]
              },
              show: true,
              textStyle: {
                color: '#333',
                fontSize: 12
              }
            }
          },
          itemStyle: {
            normal: {
              color: '#F62157' // 标志颜色
            }
          },
          zlevel: 6,
          data: DataPmList
        },
        {
          name: 'credit_pm2.5',
          type: 'scatter',
          coordinateSystem: 'geo',
          data: DataPmList,
          symbolSize: function(val) {
            return val[2] / 3
          },
          label: {
            normal: {
              formatter: '{b}',
              position: 'right',
              show: true
            },
            emphasis: {
              show: true
            }
          },
          itemStyle: {
            normal: {
              // color: '#05C3F9'
              color: '#FF8C00'
            }
          }
        },
        {
          name: 'Top 5',
          type: 'effectScatter',
          coordinateSystem: 'geo',
          // data: DataPmList.sort(function (a, b) {
          //   return b.value[2] - a.value[2]
          // }).slice(0, 5),
          data: DataPmList,
          symbolSize: function(val) {
            return val[2] / 5
          },
          showEffectOn: 'render',
          rippleEffect: {
            brushType: 'stroke'
          },
          hoverAnimation: true,
          label: {
            normal: {
              formatter: '{b}',
              position: 'right',
              show: false
            }
          },
          itemStyle: {
            normal: {
              // color: '#05C3F9',
              // shadowBlur: 10,
              // shadowColor: '#05C3F9'
              color: '#f4e925',
              shadowBlur: 50,
              shadowColor: '#EE0000'
            }
          },
          zlevel: 1
        }

      ]
    }
    if (BigDataMapChart1Option && typeof BigDataMapChart1Option === 'object') {
      BigDataMapChart1.setOption(BigDataMapChart1Option, true)
    }


  })
  .catch((error) => {
    console.log(error)
  })

// 消防预警
let BigDataMapChart2 = echarts.init(document.getElementById('LweekDeviceTime'))
let BigDataMapChart2Option = null
axios.get('http://api.datainstance.hence.cn/api/draw/temperatureList')
  .then((response) => {
    let DataPmJson = response.data.data
    let DataPmList = []
    let DataPmData = []
    DataPmJson.forEach((v, i) => {
      var Temperature = v.Temperature > v.AnomalyRate ? v.Temperature : v.AnomalyRate
      DataPmList.push({
        id: v.Id,
        name: `监测点${i + 1}`,
        value: [v.Longitude, v.Latitude].concat(Temperature)
      })
      DataPmData.push({
        name: `监测点${i + 1}`,
        value: Temperature
      })
    })

    BigDataMapChart2Option = {
      backgroundColor: 'transparent',
      title: {
        // text: '“消防预警” - 常州市',
        // subtext: '',
        left: 'center',
        top: '5%',
        textStyle: {
          color: '#ccc'
        }
      },
      tooltip: {
        trigger: 'item',
        formatter: function(params) {
          if (typeof(params.value)[2] === 'undefined') {
            return params.name + ' : ' + params.value
          } else {
            return params.name + ' : ' + params.value[2]
          }
        }
      },
      // legend: {
      //   orient: 'vertical',
      //   y: 'bottom',
      //   x: 'right',
      //   data: ['credit_pm2.5'],
      //   textStyle: {
      //     color: '#fff'
      //   }
      // },
      visualMap: {
        show: false,
        min: 0,
        max: 100,
        calculable: true,
        color: ['#d94e5d', '#eac736', '#50a3ba'],
        textStyle: {
          color: '#fff'
        }
      },
      // toolbox: {
      //     show: true,
      //     orient: 'vertical',
      //     left: 'right',
      //     top: 'center',
      //     feature: {
      //             dataView: {readOnly: false},
      //             restore: {},
      //             saveAsImage: {}
      //             }
      // },
      geo: {
        map: 'changzhou',
        top: '20%',
        bottom: '7%',
        left: '5%',
        right: '20%',
        roam: false, // 禁止鼠标操作地图
        // center: [117.98561551896913, 31.205000490896193],
        // zoom: 1.5,
        label: {
          emphasis: {
            show: false
          }
        },
        itemStyle: {
          normal: {
            areaColor: '#323c48',
            borderColor: '#111'
          },
          emphasis: {
            areaColor: '#2a333d'
          }
        }
      },
      series: [{
        // name: 'credit_pm2.5',
        type: 'effectScatter',
        coordinateSystem: 'geo',
        data: DataPmList,
        symbolSize: function(val) {
          return val[2] / 4
        },
        label: {
          normal: {
            formatter: function(params) {
              // return params.name + '：' + params.value[2] + '°C'
              return params.name
            },
            position: 'right',
            show: true
          }
        }
        // itemStyle: {
        //   normal: {
        //     color: '#ff3300',
        //     shadowBlur: 10,
        //     shadowColor: '#FF7F00'
        //   }
        // }
      }]
    }
    if (BigDataMapChart2Option && typeof BigDataMapChart2Option === 'object') {
      BigDataMapChart2.setOption(BigDataMapChart2Option, true)
    }
  })
  .catch((error) => {
    console.log(error)
  })

// 订单热度
let BigDataMapChart3 = echarts.init(document.getElementById('DeviceAllTime'))
let BigDataMapChart3Option = null
axios.get('http://api.datainstance.hence.cn/api/draw/hotList')
  .then((response) => {
    let DataPmJson = response.data.data
    let DataPmList = []
    DataPmJson.forEach((v, i) => {
      DataPmList.push([v.Longitude, v.Latitude, v.HotIndex])
    })
    BigDataMapChart3Option = {
      backgroundColor: 'transparent',
      title: {
        // text: '“区域供应链交易热度” - 常州市',
        // subtext: 'data from PM25.in',
        // sublink: 'http://www.pm25.in',
        left: 'center',
        top: '5%',
        textStyle: {
          color: '#ccc'
        }
      },
      tooltip: {
        show: false,
        trigger: 'item',
        formatter: function(params) {
          console.log(params.name)
          return params.name + ' : ' + params.value[2]
        }
      },
      visualMap: {
        show: false,
        // min: 0,
        // max: 500,
        splitNumber: 5,
        inRange: {
          color: ['#d94e5d', '#eac736', '#50a3ba'].reverse()
        },
        textStyle: {
          color: '#fff'
        }
      },
      geo: {
        map: 'changzhou',
        top: '20%',
        bottom: '7%',
        left: '5%',
        right: '5%',
        // center: [117.98561551896913, 31.205000490896193],
        // zoom: 1.5,
        label: {
          normal: {
            show: true,
            textStyle: {
              color: '#ccc'
            }
          },
          emphasis: {
            show: false
          }
        },
        roam: false, // 禁止鼠标操作地图
        itemStyle: {
          normal: {
            areaColor: '#323c48',
            borderColor: '#111'
          },
          emphasis: {
            areaColor: '#2a333d'
          }
        }
      },
      series: [{
        name: 'AQI',
        type: 'heatmap',
        coordinateSystem: 'geo',
        data: DataPmList
      }]
    }
    if (BigDataMapChart3Option && typeof BigDataMapChart3Option === 'object') {
      BigDataMapChart3.setOption(BigDataMapChart3Option, true)
    }
  })
  .catch((error) => {
    console.log(error)
  })
